import React from 'react';

import {
  Button,
  Grid, styled
} from '@mui/material';
import {
  appFormUtil,
  BaseWidget,
  ColorPickerField,
  LogoField,
  PermissionWall
} from 'modules';
import {
  fields,
  Form,
  formUtil
} from 'iron-forge-react-modules';

import { useForm } from 'react-hook-form';
import * as types from './types';
import * as dataService from './dataService';



const ControlledColorPickerField = ColorPickerField.genControllerComponent<types.IFormState>();
const ControlledLogoField = LogoField.genControllerComponent<types.IFormState>();
const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export const ButtonGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'flex-end'
});

export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.storeId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      storeName: '',
      primaryColorHex: '',
      secondaryColorHex: '',
      buttonColorHex: ''
    }
  });
  const [saveStore, saveStoreTuple] = dataService.useSaveStoreBrand(props.storeId);
  formUtil.useSetFormFields(tuple, form.setValue, [
    'storeName',
    'primaryColorHex',
    'secondaryColorHex',
    'buttonColorHex'
  ]);



  const processSubmit = React.useCallback(
    (formData: types.IFormState) => {
      saveStore(appFormUtil.trimFormStateValues(formData));
    },
    [saveStore]
  );



  const loading = tuple.loading || saveStoreTuple.loading;

  return (
    <PermissionWall.FC
      storeId={props.storeId}
      requiresPermissions={['store_updateBrand']}>
      <Form.FC
        disableDefaultOverflow
        onSubmit={form.handleSubmit(processSubmit)}>
        <BaseWidget.FC
          title="Brand"
          elAction={(
            <Button
              disabled={loading}
              variant="contained"
              type="submit">
              Save
            </Button>
          )}>
          <Grid
            container
            spacing={3}>
            <Grid
              item
              xs={12}>
              <ControlledLogoField
                existingUrl={tuple.data.logoUrl}
                fieldKey="logo"
                disabled={loading}
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}>
              <ControlledTextField
                fieldKey="storeName"
                formControl={form.control}
                isRequired
                isDisabled={loading}
                label="Store Name" />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledColorPickerField
                isRequired
                isDisabled={loading}
                label="Primary color"
                fieldKey="primaryColorHex"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledColorPickerField
                isRequired
                isDisabled={loading}
                label="Secondary color"
                fieldKey="secondaryColorHex"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={6}>
              <ControlledColorPickerField
                isRequired
                isDisabled={loading}
                label="Button color"
                fieldKey="buttonColorHex"
                formControl={form.control} />
            </Grid>
          </Grid>
        </BaseWidget.FC>
      </Form.FC>
    </PermissionWall.FC>
  );
};
